import { render } from "./GlobalMapLegend.vue?vue&type=template&id=3847f1d6"
import script from "./GlobalMapLegend.vue?vue&type=script&lang=js"
export * from "./GlobalMapLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__